import React from "react";

import AOS from "aos";
import "aos/dist/aos.css";

function Contact() {
  return (
    <div className="container mx-auto">
      <div className="flex flex-col gap-40 px-4 pb-52 pt-28 mt-72">
        {/* section1 */}
        <section className="flex flex-col items-center justify-center px-24">
          <div className="flex w-full font-bold">
            <p className="w-1/2 text-4xl leading-relaxed text-gray-800">
              <p>코끼리협동조합은</p>
              <p>언제나 새로운 만남을</p>
              <p>기다리고 있습니다.</p>
            </p>
            <div className="flex flex-col w-1/2 gap-6 ">
              {/* 이름 */}
              <div className="flex items-center w-full">
                <p className="w-1/4 text-xl font-semibold text-gray-600">
                  이름
                </p>
                <input
                  type="text"
                  id="name"
                  className="w-3/4 h-10 px-5 text-lg font-medium text-gray-800 bg-gray-100 rounded-full outline-none"
                />
              </div>
              {/* 연락처 */}
              <div className="flex items-center w-full">
                <p className="w-1/4 text-lg font-semibold text-gray-600">
                  연락처
                </p>
                <input
                  type="text"
                  id="phone"
                  className="w-3/4 h-10 px-5 text-lg font-medium text-gray-800 bg-gray-100 rounded-full outline-none"
                />
              </div>
              {/* 이메일 */}
              <div className="flex items-center w-full">
                <p className="w-1/4 text-lg font-semibold text-gray-600">
                  이메일
                </p>
                <input
                  type="text"
                  id="email"
                  className="w-3/4 h-10 px-5 text-lg font-medium text-gray-800 bg-gray-100 rounded-full outline-none"
                />
              </div>
              {/* 문의 내용 */}
              <div className="flex w-full pb-6 border-b-2 border-gray-200">
                <p className="w-1/4 mt-3 text-xl font-semibold text-gray-600">
                  문의 내용
                </p>
                <textarea
                  type="text"
                  id="content"
                  className="w-3/4 h-40 p-4 text-lg font-medium text-gray-800 bg-gray-100 outline-none rounded-3xl"
                />
              </div>
              {/* 약관 동의 */}
              <div className="w-full p-5 overflow-y-auto text-base font-medium text-gray-800 bg-gray-100 outline-none h-36 rounded-3xl">
                코끼리협동조합은(는) 개인정보보호법에 따라 이용자의 개인정보
                보호 및 권익을 보호하고 개인정보와 관련된 이용자의 고충을 처리할
                수 있도록 다음과 같은 처리 방침을 두고 있습니다.
                코끼리협동조합은(는) 개인정보보호법에 따라 이용자의 개인정보
                보호 및 권익을 보호하고 개인정보와 관련된 이용자의 고충을 처리할
                수 있도록 다음과 같은 처리 방침을 두고 있습니다.
                코끼리협동조합은(는) 개인정보보호법에 따라 이용자의 개인정보
                보호 및 권익을 보호하고 개인정보와 관련된 이용자의 고충을 처리할
                수 있도록 다음과 같은 처리 방침을 두고 있습니다.
              </div>
              <div className="flex flex-col items-end w-full gap-6">
                {/* 동의 */}
                <div className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    className="w-4 h-4 rounded-full"
                  ></input>
                  <p className="text-base font-semibold text-gray-800">
                    개인정보 취급 방침에 동의합니다.
                  </p>
                </div>
                {/* 문의하기 */}
                <button className="w-1/3 h-10 font-medium text-white rounded-full hover:bg-gradient1 bg-main">
                  문의하기
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Contact;
